import { HttpError } from 'modules/http-client'
import { Action } from 'modules/store'
import { PersonApiGetDto } from '../../shared'

export const GET_HIERARCHY_ID_TO_CURRENT = '[shared] Get hierarchy from user ID to current'
export const GET_HIERARCHY_ID_TO_CURRENT_SUCCESS = '[shared] Get hierarchy from user ID to current Success'
export const GET_HIERARCHY_ID_TO_CURRENT_FAILURE = '[shared] Get hierarchy from user ID to current Failure'

export class GetPersonHierarchyFromIdToCurrentAction implements Action {
  readonly type = GET_HIERARCHY_ID_TO_CURRENT
  constructor(public payload: number) {}
}

export class GetPersonHierarchyFromIdToCurrentSuccessAction implements Action {
  readonly type = GET_HIERARCHY_ID_TO_CURRENT_SUCCESS
  constructor(public payload: PersonApiGetDto[]) {}
}

export class GetPersonHierarchyFromIdToCurrentFailureAction implements Action {
  readonly type = GET_HIERARCHY_ID_TO_CURRENT_FAILURE
  constructor(public payload: HttpError) {}
}

export const GET_HIERARCHY_ID_TO_ROOT = '[shared] Get hierarchy from user ID to root'
export const GET_HIERARCHY_ID_TO_ROOT_SUCCESS = '[shared] Get hierarchy from user ID to root Success'
export const GET_HIERARCHY_ID_TO_ROOT_FAILURE = '[shared] Get hierarchy from user ID to root Failure'

export class GetPersonHierarchyFromIdToRootAction implements Action {
  readonly type = GET_HIERARCHY_ID_TO_ROOT
  constructor(public payload: number) {}
}

export class GetPersonHierarchyFromIdToRootSuccessAction implements Action {
  readonly type = GET_HIERARCHY_ID_TO_ROOT_SUCCESS
  constructor(public payload: PersonApiGetDto[]) {}
}

export class GetPersonHierarchyFromIdToRootFailureAction implements Action {
  readonly type = GET_HIERARCHY_ID_TO_ROOT_FAILURE
  constructor(public payload: HttpError) {}
}

type PersonActions =
  | GetPersonHierarchyFromIdToCurrentAction
  | GetPersonHierarchyFromIdToCurrentSuccessAction
  | GetPersonHierarchyFromIdToCurrentFailureAction
  | GetPersonHierarchyFromIdToRootAction
  | GetPersonHierarchyFromIdToRootSuccessAction
  | GetPersonHierarchyFromIdToRootFailureAction

export default PersonActions



// WEBPACK FOOTER //
// ./src/app/shared/store/person.actions.ts